import { useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { HandleClickOutside } from '../../../common/HandleClickOutside'
import { DropdownList } from '../../../common/dropdown/DropdownList'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import { changeReCountNotifications } from '../../../layout/store/slice'
import { getListAction } from '../../constants'
import {
  changeIsRead,
  changeIsScroll,
  deleteNotification,
} from '../../store/slice'
import { deleteNotifications, updateReadStatus } from '../../store/thunk'
import classes from '../index.module.scss'

export const Action = ({ id, isRead, isLastIndex, screenType, timeType }) => {
  const dispatch = useDispatch()
  const ref = useRef()
  const childrenRef = useRef()
  const [isShow, setIsShow] = useState(false)

  const onDelete = () => {
    dispatch(deleteNotifications({ ids: [id] }))
      .unwrap()
      .then(() => {
        dispatch(changeIsScroll(false))
        dispatch(
          deleteNotification({
            screenType,
            timeType,
            id,
          }),
        )
        dispatch(changeReCountNotifications())
      })
      .catch(() => {})
  }

  const updateStatus = () => {
    dispatch(
      updateReadStatus({
        ids: [id],
        isRead: !isRead,
      }),
    )
      .unwrap()
      .then(() => {
        dispatch(changeIsScroll(false))
        dispatch(
          changeIsRead({
            screenType,
            timeType,
            id,
            isRead: !isRead,
          }),
        )
        dispatch(changeReCountNotifications())
      })
      .catch(() => {})
  }

  const actionClickMap = {
    'systemNotifications.DELETE': onDelete,
    'systemNotifications.MARK_AS_READ': updateStatus,
    'systemNotifications.MARK_AS_UNREAD': updateStatus,
  }

  const onClick = () => {
    setIsShow(!isShow)
  }

  const handleClickOutside = () => {
    setIsShow(false)
  }

  return (
    <Element
      ref={ref}
      className={[
        'dFlex alignItemsCenter justifyContentCenter mr1 positionRelative',
        classes.actions,
      ].join(' ')}
      style={{
        backgroundColor: '#f3f3f3',
      }}
      onClick={onClick}
    >
      <Icon className="icon-menu-dot-ver" style={{ lineHeight: 0 }} />
      {isShow && (
        <div
          style={{ bottom: isLastIndex ? 8 : -52 }}
          className={['positionAbsolute', classes.dropdown].join(' ')}
        >
          <HandleClickOutside
            exceptRef={[ref, childrenRef]}
            handleClickOutside={handleClickOutside}
          >
            <DropdownList
              childrenRef={childrenRef}
              data={getListAction(isRead)}
              onClickItem={(item) => {
                actionClickMap[item.label]()
                setIsShow(false)
              }}
              appendItemStyle={{ whiteSpace: 'nowrap' }}
            />
          </HandleClickOutside>
        </div>
      )}
    </Element>
  )
}
